export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9982.623a7872.jpg";